import React from 'react'
import './Careers.scss'
import { Link } from 'react-router-dom'

const Careers = () => {
  const openPositions = [
    {
      id: 1,
      title: 'Senior VoIP Engineer',
      department: 'Telecommunications',
      location: 'Pretoria, South Africa / Remote',
      type: 'Full-time',
      description: 'We are looking for an experienced VoIP engineer to join our telecommunications team. You will work on cutting-edge SIP server solutions and billing platforms.',
      requirements: [
        '5+ years experience with OpenSIPS, CGRates',
        'Strong knowledge of SIP protocols',
        'Experience with billing systems',
        'Proficiency in Node.js or Golang'
      ]
    },
    {
      id: 2,
      title: 'Data Engineer',
      department: 'Data Solutions',
      location: 'Pretoria, South Africa / Remote',
      type: 'Full-time',
      description: 'Help us build scalable data warehousing solutions using ClickHouse, Redpanda, and modern data pipelines.',
      requirements: [
        'Experience with data warehousing',
        'Knowledge of ClickHouse or similar',
        'Python or Go programming skills',
        'Understanding of ETL processes'
      ]
    }
  ]

  const benefits = [
    { icon: 'fas fa-dollar-sign', title: 'Competitive Salary', description: 'Attractive compensation packages' },
    { icon: 'fas fa-home', title: 'Remote Work', description: 'Work from anywhere flexibility' },
    { icon: 'fas fa-graduation-cap', title: 'Learning & Growth', description: 'Continuous skill development' },
    { icon: 'fas fa-heart', title: 'Health Benefits', description: 'Medical and wellness programs' },
    { icon: 'fas fa-calendar', title: 'Flexible Hours', description: 'Work-life balance' },
    { icon: 'fas fa-users', title: 'Great Team', description: 'Collaborative environment' }
  ]

  return (
    <section id="careers" className="careers-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 text-center">
            <h2 className="section__heading">Join Our Team</h2>
            <p className="section-subtitle">
              Build innovative software solutions with a team that's passionate about technology
            </p>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div className="careers-intro">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <h3>Why Work at Redemption Inc Softwares?</h3>
                  <p>
                    We're a fast-growing software development company specializing in telecommunications, 
                    mobile applications, and data solutions. Join us to work on cutting-edge projects 
                    with modern technologies and a team that values innovation and collaboration.
                  </p>
                  <div className="benefits-grid">
                    {benefits.map((benefit, index) => (
                      <div key={index} className="benefit-item">
                        <i className={benefit.icon}></i>
                        <div>
                          <h5>{benefit.title}</h5>
                          <p>{benefit.description}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="careers-visual">
                    <div className="animated-code">
                      <div className="code-line">
                        <span className="code-keyword">const</span> 
                        <span className="code-variable"> team</span> = 
                        <span className="code-string"> 'amazing'</span>;
                      </div>
                      <div className="code-line">
                        <span className="code-keyword">const</span> 
                        <span className="code-variable"> projects</span> = 
                        <span className="code-string"> 'cutting-edge'</span>;
                      </div>
                      <div className="code-line">
                        <span className="code-keyword">const</span> 
                        <span className="code-variable"> future</span> = 
                        <span className="code-string"> 'bright'</span>;
                      </div>
                      <div className="code-line">
                        <span className="code-function">join</span>
                        <span className="code-bracket">(</span>
                        <span className="code-variable">team</span>
                        <span className="code-bracket">)</span>;
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12">
            <h3 className="open-positions-title">Open Positions</h3>
          </div>
        </div>

        <div className="row">
          {openPositions.map((position) => (
            <div key={position.id} className="col-lg-6 col-md-6 col-12">
              <div className="position-card">
                <div className="position-header">
                  <h4>{position.title}</h4>
                  <div className="position-meta">
                    <span className="position-dept">{position.department}</span>
                    <span className="position-location">
                      <i className="fas fa-map-marker-alt"></i> {position.location}
                    </span>
                    <span className="position-type">{position.type}</span>
                  </div>
                </div>
                <p className="position-description">{position.description}</p>
                <div className="position-requirements">
                  <h5>Key Requirements:</h5>
                  <ul>
                    {position.requirements.map((req, index) => (
                      <li key={index}>{req}</li>
                    ))}
                  </ul>
                </div>
                <div className="position-footer">
                  <Link 
                    to="/job-application" 
                    state={{ job: position }}
                    className="btn btn-primary"
                  >
                    Apply Now
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="row">
          <div className="col-lg-12 text-center">
            <div className="careers-cta">
              <h3>Don't see a position that fits?</h3>
              <p>We're always looking for talented individuals. Send us your resume!</p>
              <Link to="/#contact" className="btn btn-outline">
                Send Your Resume
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Careers

